import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_DELETE_API_URL,
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_DELETE_MUTATION,
  AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS,
} from '../constants';

export default function useDeleteNoneNegativeCarryoverMutation(): IContextMutationResult<void, Error, number> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATE_NONE_NEGATIVE_CARRYOVER_DELETE_MUTATION],
    mutationFn: (itemId) => fetchDelete<void>(
      AFFILIATE_NONE_NEGATIVE_CARRYOVER_DELETE_API_URL,
      {
        permission: AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS.DELETE,
        urlParams: {
          itemId,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('removed');
    },
  });
}
